function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.46,0A12.46,12.46,0,1,0,24.91,12.46,12.46,12.46,0,0,0,12.46,0Zm0,24.16A11.65,11.65,0,0,1,4.5,21l3.3-3.3-.52-.53L4,20.51A11.7,11.7,0,0,1,20.51,4L16,8.48l.53.53L21,4.5a11.7,11.7,0,0,1-8.57,19.66Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.93,6.57V4.87a.52.52,0,0,0,.27-.45V3.87a.51.51,0,0,0-.51-.51H10.27a.51.51,0,0,0-.51.51v.55a.5.5,0,0,0,.22.42V6.57A4.33,4.33,0,0,1,9.22,9a4.4,4.4,0,0,0-.73,2.45v8.41a1.72,1.72,0,0,0,1.68,1.77h4.58a1.72,1.72,0,0,0,1.67-1.77V11.45A4.4,4.4,0,0,0,15.69,9,4.33,4.33,0,0,1,14.93,6.57Zm-.71.59H10.69a5.65,5.65,0,0,0,0-.59V4.93h3.45V6.57A5.65,5.65,0,0,0,14.22,7.16Zm1.46,12.7a1,1,0,0,1-.93,1H10.17a1,1,0,0,1-.93-1V11.45a3.69,3.69,0,0,1,.6-2,5.43,5.43,0,0,0,.7-1.51h3.83a5.43,5.43,0,0,0,.7,1.51,3.62,3.62,0,0,1,.61,2Z"
});

function SvgDairyFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 20,
    fill: "currentColor",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.91 24.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDairyFree);
export default __webpack_public_path__ + "static/media/DairyFree.9454dbaf.svg";
export { ForwardRef as ReactComponent };